<div class="wrapper">
    <div class="label selenium-sort-by-text">Sort by</div>
    <div
        class="selenium-sort-by-dropdown gtm-sort-by-dropdown"
        [attr.data-gtmlabel]="selectedOption"
        [ngClass]="{ 'on-search': isOnSearch }"
    >
        <ng-select
            [items]="sortByOptions"
            bindLabel="label"
            dropdownPosition="bottom"
            bindValue="value"
            [multiple]="false"
            [hideSelected]="true"
            [searchable]="false"
            [clearable]="false"
            [markFirst]="true"
            placeholder="Relevance"
            [(ngModel)]="selectedOption"
            (change)="changeRanking($event, selectedOption)"
            class="dropdown"
        >
        </ng-select>
    </div>
</div>
